import { SortType } from '@stylehaven/components';

import { CellOptions } from './cell-options/cell-options.entity';
import { ColumnDefData } from './column-definition-data.entity';
import { ColumnFilterField } from './column-filter-field.entity';
import { ColumnWidth } from './column-width.entity';

export class ColumnDef<P> implements ColumnDefData<P> {
    private static readonly defaults: Omit<ColumnDefData<any>, 'key' | 'sortField'> = {
        label: '',
        width: ColumnWidth.NORMAL,
        defaultValue: '',
        showHeader: true,
        isEnabled: () => true,
        sortable: false
    };

    public readonly key: string;
    public readonly label: string = '';
    public readonly width: ColumnWidth = ColumnWidth.NORMAL;
    public readonly defaultValue: string = '';
    public readonly showHeader: boolean = true;
    public readonly options: CellOptions;
    public readonly isEnabled: (record: P) => boolean = () => true;
    public readonly sortable: boolean = false;
    public readonly sortField: string;
    public readonly sortType?: SortType;

    /**
     * The labelled free-text inputs this column's filter popover holds, for a column that renders more than
     * one field. Empty for every column that filters on its own single field.
     */
    public readonly filterFields: readonly ColumnFilterField[] = [];

    constructor(qp: Pick<ColumnDefData<P>, 'key'> & Partial<ColumnDefData<P>>) {
        const merged: ColumnDefData<P> = { ...ColumnDef.defaults, ...qp };
        this.key = merged.key;
        this.label = merged.label;
        this.width = merged.width;
        this.defaultValue = merged.defaultValue;
        this.showHeader = merged.showHeader;
        this.isEnabled = merged.isEnabled;
        this.options = merged.options;
        this.sortable = merged.sortable;
        this.sortField = merged.sortField ?? merged.key;
        this.sortType = merged.sortType;
        this.filterFields = merged.filterFields ?? [];
    }

    enabledForRecord(record: P) {
        return this.isEnabled(record);
    }

    toString(): string {
        return this.key;
    }
}
